import { useEffect, useState } from "react";
import { api } from "../../api";

interface Settings {
  sender_name: string;
  sender_email: string;
  opt_out_line: string;
  daily_send_limit: number;
  follow_up_min_days: number;
  ai_provider?: string;
  email_provider?: string;
  allowed_countries: string[];
}

export function GrowthSettings() {
  const [s, setS] = useState<Settings | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const r = await api.getGrowthSettings();
      setS(r.settings as Settings);
    })();
  }, []);

  async function save() {
    if (!s) return;
    setSaving(true);
    try {
      const r = await api.updateGrowthSettings(s);
      setS(r.settings as Settings);
    } finally { setSaving(false); }
  }

  if (!s) return <div className="sg-empty">Loading…</div>;

  return (
    <div className="sg-panel" style={{ maxWidth: 640 }}>
      <div className="sg-panel-pad sg-stack" style={{ gap: 14 }}>
        <Field label="Sender name">
          <input className="sg-input" value={s.sender_name} onChange={(e) => setS({ ...s, sender_name: e.target.value })} />
        </Field>
        <Field label="Sender email">
          <input className="sg-input" value={s.sender_email} onChange={(e) => setS({ ...s, sender_email: e.target.value })} />
        </Field>
        <Field label="Opt-out line (added to every email)">
          <input className="sg-input" value={s.opt_out_line} onChange={(e) => setS({ ...s, opt_out_line: e.target.value })} />
        </Field>
        <div className="sg-row" style={{ gap: 12 }}>
          <Field label="Daily send limit">
            <input
              className="sg-input"
              type="number"
              value={s.daily_send_limit}
              onChange={(e) => setS({ ...s, daily_send_limit: Number(e.target.value) })}
            />
          </Field>
          <Field label="Follow-up min days">
            <input
              className="sg-input"
              type="number"
              value={s.follow_up_min_days}
              onChange={(e) => setS({ ...s, follow_up_min_days: Number(e.target.value) })}
            />
          </Field>
        </div>
        <Field label="Allowed countries (ISO codes, comma-separated)">
          <input
            className="sg-input"
            value={s.allowed_countries.join(", ")}
            onChange={(e) => setS({ ...s, allowed_countries: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })}
          />
        </Field>
        <div className="sg-row" style={{ justifyContent: "flex-end" }}>
          <button className="sg-btn sg-btn-primary sg-btn-sm" onClick={save} disabled={saving}>
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
      <span style={{ fontSize: 12, color: "var(--sg-ink-3)", fontWeight: 600 }}>{label}</span>
      {children}
    </label>
  );
}
